import request from '../utils/fetch'
export function orderAfterSaleList (data) {
  return request({
    url: '/admin/orders/orderAfterSaleList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}

export function orderAfterSaleInfo (data) {
  return request({
    url: '/admin/orders/orderAfterSaleInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function applyList (data) {
  return request({
    url: '/store/user/applyList',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function changeStatus (data) {
  return request({
    url: '/store/user/changeStatus',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function applyInfo (data) {
  return request({
    url: '/store/user/applyInfo',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function sendSms (data) {
  return request({
    url: '/huaweiSms/sendSms',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}



